module.exports = __webpack_public_path__ + "assets/img/8ea7-mv.svg";